import React from 'react';
import { motion } from 'framer-motion';
import { Target, TrendingUp, Trophy, Zap } from 'lucide-react';
import { dashboardData } from './data';
export function KpiRow() {
  const {
    kpis
  } = dashboardData;
  const cards = [{
    title: 'Total Points (MTD)',
    value: kpis.totalPointsMtd.toLocaleString(),
    subtext: '+12% vs last month',
    icon: Trophy,
    iconColor: 'text-[#0a1e5e]',
    iconBg: 'bg-blue-50',
    valueColor: 'text-[#0a1e5e]'
  }, {
    title: 'Team Goal',
    value: kpis.teamGoal.toLocaleString(),
    subtext: 'Points target for May',
    icon: Target,
    iconColor: 'text-[#0a1e5e]',
    iconBg: 'bg-slate-100',
    valueColor: 'text-[#0a1e5e]'
  }, {
    title: '% of Goal',
    value: `${kpis.percentOfGoal.toFixed(1)}%`,
    subtext: 'On track for month end',
    icon: TrendingUp,
    iconColor: 'text-green-600',
    iconBg: 'bg-green-50',
    valueColor: 'text-green-600'
  }, {
    title: 'Speed Bonus Earned',
    value: `+${kpis.speedBonusEarned.toLocaleString()}`,
    subtext: 'Points from fast closings',
    icon: Zap,
    iconColor: 'text-orange-500',
    iconBg: 'bg-orange-50',
    valueColor: 'text-orange-500'
  }];
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-133">
      {cards.map((card, index) => <motion.div key={index} initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: index * 0.1
    }} className="bg-white rounded-2xl p-5 border border-slate-200 shadow-sm flex items-center gap-4 min-h-[96px]" data-id="element-134">
          <div className={`w-12 h-12 rounded-full flex items-center justify-center shrink-0 ${card.iconBg} ${card.iconColor}`} data-id="element-135">
            <card.icon size={24} data-id="element-136" />
          </div>
          <div data-id="element-137">
            <p className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-138">
              {card.title}
            </p>
            <p className={`text-2xl font-black leading-none mb-1 ${card.valueColor}`} data-id="element-139">
              {card.value}
            </p>
            <p className="text-[11px] font-medium text-slate-500" data-id="element-140">
              {card.subtext}
            </p>
          </div>
        </motion.div>)}
    </div>;
}